export const MAX_POI_IMAGES = 10
export const BYTES_PER_MB = 1024 * 1024

/** Upload cap for POI/tour images. */
export const MAX_IMAGE_SIZE_MB = 20
export const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * BYTES_PER_MB

/** Upload cap for tenant branding images (logo, favicon). */
export const MAX_BRANDING_IMAGE_SIZE_MB = 2
export const MAX_BRANDING_IMAGE_SIZE_BYTES = MAX_BRANDING_IMAGE_SIZE_MB * BYTES_PER_MB

export const ACCEPTED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/webp'] as const

export const IMAGE_RESIZE_TARGETS = {
  thumbnail: 150,
  medium: 600,
  large: 1200,
} as const
